var exports = {
  "nM": "TokenRow.module__row___M3ZqQk",
  "Qq": "TokenRow.module__text___M3ZqQk",
  "Pf": "TokenRow.module__label___M3ZqQk",
  "cG": "TokenRow.module__variableName___M3ZqQk",
  "ne": "TokenRow.module__controls___M3ZqQk",
  "ZZ": "TokenRow.module__field___M3ZqQk",
  "M8": "TokenRow.module__textField___M3ZqQk",
  "hF": "TokenRow.module__input___M3ZqQk",
  "EX": "TokenRow.module__colorInput___M3ZqQk",
  "yF": "TokenRow.module__divider___M3ZqQk",
  "nf": "TokenRow.module__swatch___M3ZqQk",
  "ue": "TokenRow.module__fontPreview___M3ZqQk",
  "oO": "TokenRow.module__popover___M3ZqQk",
  "WA": "TokenRow.module__resetButton___M3ZqQk",
  "uq": "TokenRow.module__resetSpacer___M3ZqQk",
};

module.exports = exports;
